export function toggleFieldError(field, toggle, message) {
    let label, span;
    // TODO refactor and remove custom function
    if (
        field.hasAttribute("data-custom-error") &&
        typeof customToggleFieldError === "function"
    ) {
        customToggleFieldError(field, toggle, message);
    } else {
        label = document.querySelector("label[for=" + field.id + "]");
        if (field.hasAttribute("item-id")) {
            label.classList[toggle ? "add" : "remove"]("show");
        }
        span = label.querySelector("span.error");
        field.classList[toggle ? "add" : "remove"]("is-invalid");
        label.classList[toggle ? "add" : "remove"]("error");
        span.textContent = toggle ? message : "";
        field.setCustomValidity(toggle ? message : "");
    }
}
